export default __webpack_public_path__ + "static/media/preview-dark.fbed90bb.svg";